import api from './api';

const featuresService = {
  getAll: async () => {
    const response = await api.get('/features');
    return response.data.features || response.data.data || [];
  },

  getByPetType: async (petTypeId) => {
    const response = await api.get(`/features/pet-type/${petTypeId}`);
    return response.data.features || response.data.data || [];
  },

  getById: async (id) => {
    const response = await api.get(`/features/${id}`);
    return response.data.feature || response.data.data || response.data;
  },

  create: async (data) => {
    const response = await api.post('/features', data);
    return response.data.feature || response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/features/${id}`, data);
    return response.data.feature || response.data.data || response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/features/${id}`);
    return response.data;
  },

  toggleStatus: async (id) => {
    const response = await api.patch(`/features/${id}/toggle-status`);
    return response.data.feature || response.data.data || response.data;
  },
};

export default featuresService;
